import { Box, Grid2, Skeleton, Typography } from "@mui/material";
import React, { useContext } from "react";
import TextBankInfo from "../common/TextBankInfo";
import TextBankInfoValue from "../common/TextBankInfoValue";
import { RootContext } from "../layout";

export default function WalletPayment({ amount = 5000, loading = false }) {
  const { balances } = useContext(RootContext);
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        sx={{
          backgroundImage: "url(/images/image/bg-image.png)", // Replace with your image URL
          backgroundSize: "cover", // Cover the entire box
          backgroundPosition: "center", // Center the image
          backgroundRepeat: "no-repeat", // Prevent the image from repeating
          minHeight: 92,
          color: "black",
          borderRadius: "16px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography variant="body" fontWeight={500}>
          Current Balance
        </Typography>
        {loading ? (
          <Skeleton width="50%" height={50} sx={{ backgroundColor: "white" }} />
        ) : (
          <Typography variant="body" fontWeight={700}>
            ${Number(balances[0].balance).toLocaleString("en-US")}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          bgcolor: "background.default",
          minHeight: 150,
          color: "black",
          borderRadius: "16px",
          padding: "24px",
        }}
      >
        <Typography variant="body" fontWeight={500}>
          Details
        </Typography>
        <Grid2 container marginTop={2} spacing={1}>
          <Grid2 size={6}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              gap={2}
            >
              <TextBankInfo>Current Balance:</TextBankInfo>
              <TextBankInfo>Your Order:</TextBankInfo>
              <div></div>
              <TextBankInfo>Remaining balance:</TextBankInfo>
            </Box>
          </Grid2>
          <Grid2 size={6}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              gap={2}
            >
              {loading ? (
                <>
                  <Skeleton variant="rounded" width="70%" height={20} />
                  <Skeleton variant="rounded" width="70%" height={20} />
                  <div></div>
                  <Skeleton variant="rounded" width="70%" height={20} />
                </>
              ) : (
                <>
                  <TextBankInfoValue>
                    $ {Number(balances[0].balance).toLocaleString("en-US")}
                  </TextBankInfoValue>
                  <TextBankInfoValue>
                    -${Number(amount).toLocaleString("en-US")}
                  </TextBankInfoValue>
                  <div></div>
                  <TextBankInfoValue>
                    ${" "}
                    {Number(balances[0].balance - amount).toLocaleString(
                      "en-US"
                    )}
                  </TextBankInfoValue>
                </>
              )}
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
}
